export default __webpack_public_path__ + "static/media/car-1.ba8f10f5.png";